import React, {Component} from 'react';
import PropTypes from 'prop-types';
import striptags from "striptags";
import api from "../../../../../../../../../api";
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SelectAnswers from "../../../../../../../Structure/components/SelectAnswers";
import {FormattedMessage} from "react-intl";
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import Select from "react-select";
import SelectExcludings from "../../../../../../../Structure/components/SelectExcludings";

class ColumnTfoot extends Component {
  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      answer: false,
      excluding: false,
      value: 1,
      content: null,
      modalIsOpen: false,
    };

    this.getAnswer = this.getAnswer.bind(this);
    this.modalToggle = this.modalToggle.bind(this);
    this.save = this.save.bind(this);
  }

  getAnswer(answerId){
    return this.props.question.answers.find(answer => answer.id === answerId);
  }

  modalToggle(answer = false, content = null){
    this.setState({
      modalIsOpen: !this.state.modalIsOpen,
      answer,
      content,
      excluding: false,
      value: 1,
    });
  }

  save(){
    const {answer, value, excluding, content} = this.state;
    const {question, responsesSelected} = this.props;

    this.setState({
      saving: true,
    });

    let data = {
      responses: responsesSelected,
      answer,
      excluding,
      value,
      content,
    };

    api.questionResponse.question.patchDetails(question.id, data)
    .then(data => {
      this.setState({
        saving: false,
        answer: false,
        excluding: false,
        content: null,
        modalIsOpen: false,
      });

      this.props.onSaved();
    })
    .catch(res => {
      this.setState({
        saving: false,
      });
    });
  }

  render() {
    const {modalIsOpen, answer, saving, value, content} = this.state;
    const {responsesSelected, question} = this.props;

    const options = [
      {
        label: <span>Wybrał</span>,
        value: 1,
      },
      {
        label: <span>Nie wybrał</span>,
        value: 0,
      },
    ];

    return <React.Fragment>
      {question.answers.map((answer, key) => {
        return <React.Fragment key={key.toString()}>
          <td>
            <Button
              onClick={() => this.modalToggle(answer.id)}
              disabled={responsesSelected.length === 0}
              size="sm"
              color="secondary"
              className="w-100 text-center"
            >Zmień</Button>
          </td>
          {answer.isOpen && <td>
            <Button
              onClick={() => this.modalToggle(answer.id, '')}
              disabled={responsesSelected.length === 0}
              size="sm"
              color="secondary"
              className="w-100 text-center"
            >Zmień</Button>
          </td>}
        </React.Fragment>
      })}

      {question.excludings.length > 0 && <td>
        <Button
          onClick={() => this.modalToggle(false)}
          disabled={responsesSelected.length === 0}
          size="sm"
          color="secondary"
          className="w-100 text-center"
        >Zmień</Button>
      </td>}

      {modalIsOpen && <Modal isOpen={true} toggle={this.modalToggle} size="xl">
        <ModalHeader tag="h2" toggle={this.modalToggle}>Zmień odpowiedź dla wybranych wywiadów</ModalHeader>
        <hr className="my-0"/>
        <ModalBody>
          <Form>
            <FormGroup row>
              <Label md={3}>Liczba zaznaczonych wywiadów:</Label>
              <Col md={9} className="d-flex align-items-center">{responsesSelected.length}</Col>
            </FormGroup>
            {answer && <FormGroup row>
              <Label md={3}>Zmiana dotyczy odpowiedzi:</Label>
              <Col md={9} className="d-flex align-items-center">{striptags(this.getAnswer(answer).content)}</Col>
            </FormGroup>}
            {(answer && content === null) && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień odpowiedź na:</Label>
              <Col md={9} className="d-flex align-items-center">
                <Select
                  options={options}
                  value={options.find(o => o.value === value)}
                  placeholder="Usuń odpowiedź lub wybierz aby zmienić"
                  className="w-100"
                  onChange={option => this.setState({value: option ? option.value : 0})}
                />
              </Col>
            </FormGroup>}
            {content !== null && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień odpowiedź wpisywaną na:</Label>
              <Col md={9} className="d-flex align-items-center">
                <Input type="text" onChange={e => this.setState({content: e.target.value})} />
              </Col>
            </FormGroup>}
            {!answer && <FormGroup row>
              <Label md={3}>W zaznaczonych wywiadach zmień na odpowiedź wykluczającą:</Label>
              <Col md={9} className="d-flex align-items-center">
                <SelectExcludings
                  questionId={question.id}
                  className="w-100"
                  onChange={excluding => this.setState({excluding: excluding || false})}
                />
              </Col>
            </FormGroup>}
          </Form>
        </ModalBody>
        <ModalFooter>
          <FormattedMessage id="_.button.cancel">{
            (message) =>
              <Button color="secondary" className="mb-0" onClick={this.modalToggle}>{message}</Button>
          }</FormattedMessage>
          <FormattedMessage id="_.button.save">{
            (message) => <LaddaButton
              className="btn btn-primary btn-ladda mb-0"
              loading={saving}
              data-style={ZOOM_OUT}
              onClick={() => this.save()}
            >
              {message}
            </LaddaButton>
          }</FormattedMessage>
        </ModalFooter>
      </Modal>}
    </React.Fragment>;
  }
}

ColumnTfoot.propTypes = {
  question: PropTypes.shape({
    type: PropTypes.oneOf(['multi']),
    answers: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      position: PropTypes.number.isRequired,
      content: PropTypes.string.isRequired,
    }),),
  }).isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default ColumnTfoot;